import {IForm} from '@/components/types'
import {useSearchDateShortcut} from "@/hooks/useSearch";

const shortcuts = useSearchDateShortcut()
export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'third',
      type: 'select',
      label: '所属第三方',
      clearable: true,
      placeholder: '请选择所属第三方'
    },
    {
      field: 'corpName',
      type: 'select',
      label: '所属主体',
      placeholder: '请选择所属主体',
      filterable: true,
      clearable: true
    },
    {
      field: 'userId',
      type: 'input',
      label: '工作微信号',
      clearable: true,
      placeholder: '请输入工作微信号'
    },
    {
      field: 'channel',
      type: 'select',
      label: '来源标签',
      filterable: true,
      clearable: true,
      placeholder: '请选择来源标签'
    },
    {
      field: 'nickName',
      type: 'input',
      label: '客户昵称',
      clearable: true,
      placeholder: '请输入客户昵称'
    },
    {
      field: 'unionId',
      type: 'input',
      label: 'UnionId',
      clearable: true,
      placeholder: '请输入客户unionId'
    },
    {
      field: 'timeSlot',
      type: 'dateTimePicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      field: 'cfddFlag',
      type: 'switch',
      label: '重复兜底开关'
    },
  ]
}
